import { message, Form, Switch } from 'antd';
import Card, { CardEdit } from 'components/Card/Card';
import { useEditCard } from 'components/Card/useEditCard';
import TabularList from 'components/TabularList/TabularList';
import { useAddressFieldsData } from 'components/AddressFields/AddressFieldsFlat';
import Message from 'components/ui/Message';
import { providerService } from 'services';
import FormattedAddress from 'components/FormattedAddress/FormattedAddress';
import classNames from 'classnames';

export function MailingAddress({ application, careFacility, setCareFacility, isEditable = false }) {
  const [form] = Form.useForm();

  const { isEditing, editProps } = useEditCard({
    id: 'mailing-address',
    onEditStart: () =>
      form.setFieldsValue({
        mailingAddressSameAsOrg: careFacility?.mailingAddressSameAsOrg,
        mailingAddress: careFacility?.mailingAddress,
      }),
    onSave: async () => {
      await form.validateFields();
      const values = form.getFieldsValue();
      const payload = {
        mailingAddressSameAsOrg: values.mailingAddressSameAsOrg,
        mailingAddress: values.mailingAddress,
      };
      await providerService.updateCenter(payload, careFacility?.id);
      const updatedCareFacility = await providerService.getCenterById(Number(careFacility?.id));
      setCareFacility(updatedCareFacility);
      form.resetFields();
      message.success('Mailing address updated');
    },
    onDiscard: () => form.resetFields(),
  });

  const mailingAddressSameAsOrg = Form.useWatch('mailingAddressSameAsOrg', form);

  const addressFieldsData = useAddressFieldsData({
    form,
    addressKey: 'mailingAddress',
    isEditing,
    addressValue: careFacility?.mailingAddress,
    disabled: mailingAddressSameAsOrg || editProps.loading,
  });

  const showAddressSummary = !isEditing && careFacility?.mailingAddressSameAsOrg;

  return (
    <Card
      className="mt-8"
      title="Mailing address"
      extra={isEditable ? <CardEdit {...editProps} /> : null}
      noBodyPadding
      stickyHeader
    >
      <Form form={form} disabled={editProps.loading}>
        <TabularList
          indented
          data={[
            ...(showAddressSummary
              ? []
              : [
                  {
                    title: 'Same as organization',
                    value: isEditing ? (
                      <Form.Item name="mailingAddressSameAsOrg" valuePropName="checked" className="mb-0">
                        <Switch />
                      </Form.Item>
                    ) : careFacility?.mailingAddressSameAsOrg ? (
                      'Yes'
                    ) : (
                      'No'
                    ),
                  },
                ]),
            ...(showAddressSummary || (isEditing && mailingAddressSameAsOrg) ? [] : addressFieldsData),
          ]}
        />

        {(showAddressSummary || (isEditing && mailingAddressSameAsOrg)) && (
          <Message
            title="Using organization's mailing address"
            className={classNames('mx-6 mb-6', isEditing ? '' : 'mt-6')}
          >
            <FormattedAddress address={careFacility?.mailingAddress} />
          </Message>
        )}
      </Form>
    </Card>
  );
}
